import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="visibility-control"
export default class extends Controller {
  static targets = ["passwordInput", "toggleIcon", "hidden", "visible"];

  toggle() {
    if (this.hasPasswordInputTarget) {
      const passwordInput = this.passwordInputTarget;
      const toggleIcon = this.toggleIconTarget;

      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        toggleIcon.classList.remove("fa-eye-slash");
        toggleIcon.classList.add("fa-eye");
      } else {
        passwordInput.type = "password";
        toggleIcon.classList.remove("fa-eye");
        toggleIcon.classList.add("fa-eye-slash");
      }
    }

    if (this.hasHiddenTarget && this.hasVisibleTarget) {
      this.hiddenTarget.classList.toggle("hidden");
      this.visibleTarget.classList.toggle("hidden");

      if (this.visibleTarget.classList.contains("hidden")) {
        this.toggleIconTarget.classList.remove("fa-eye");
        this.toggleIconTarget.classList.add("fa-eye-slash");
      } else {
        this.toggleIconTarget.classList.remove("fa-eye-slash");
        this.toggleIconTarget.classList.add("fa-eye");
      }
    }
  }
}
